// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"VIP_Tabs__tabWrapper"};